import React, { Component } from "react";

class section6 extends Component {
  render() {
    return (
      <div className="container-fluid section6">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 text-center">
            <div className="content6">
              <p className="text-light text6">
                Get Started Today! Lead With Business Or With Products
              </p>
              <div className="btnDiv">
                <button className="btn text-light yb6">
                  Ready to take first step
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default section6;
